var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.portefeuilles
    ? _c(
        "aside",
        { staticClass: "menu" },
        [
          _c(
            "b-modal",
            {
              attrs: { active: _vm.showModal, "has-modal-card": "" },
              on: {
                "update:active": function($event) {
                  _vm.showModal = $event
                }
              }
            },
            [
              _c("CGAModal", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showModal,
                    expression: "showModal"
                  }
                ],
                attrs: {
                  documentUrl: _vm.pdfUrl,
                  "portefeuille-id": _vm.cgaPortefeuilleId,
                  "show-modal": _vm.showModal
                },
                on: {
                  "close-modal": function($event) {
                    _vm.showModal = false
                  }
                }
              })
            ],
            1
          ),
          _vm._l(_vm.portefeuilles, function(portefeuille) {
            return _c("div", { key: "portefeuille" + portefeuille.id }, [
              _c(
                "div",
                { staticClass: "menu-head" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "has-toggle",
                      on: {
                        click: function($event) {
                          return _vm.handleToggleClick(portefeuille.id)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _vm.cgaPending === portefeuille.id
                            ? _c("b-icon", {
                                attrs: {
                                  icon: "spinner",
                                  "custom-class": "fa-spin"
                                }
                              })
                            : _c("b-icon", {
                                attrs: {
                                  icon:
                                    _vm.expandedPortefeuille === portefeuille.id
                                      ? "minus-square"
                                      : "plus-square"
                                }
                              })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "router-link",
                    {
                      attrs: { to: "/portefeuille/" + portefeuille.id + "/" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.getCGA(portefeuille.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(portefeuille.name) + "\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.expandedPortefeuille === portefeuille.id,
                      expression: "expandedPortefeuille === portefeuille.id"
                    }
                  ],
                  staticClass: "menu-list"
                },
                _vm._l(_vm.sites, function(site) {
                  return _c("li", { key: "site" + site.id }, [
                    _c(
                      "a",
                      {
                        staticClass: "has-toggle",
                        on: {
                          click: function($event) {
                            return _vm.toggleExpand(site.id)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("b-icon", {
                              attrs: {
                                icon: _vm.isExpanded(site.id)
                                  ? "minus-square"
                                  : "plus-square"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(
                          "\n          " + _vm._s(site.name) + "\n        "
                        )
                      ]
                    ),
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isExpanded(site.id),
                            expression: "isExpanded(site.id)"
                          }
                        ]
                      },
                      _vm._l(site.biens, function(bien) {
                        return _c(
                          "li",
                          { key: "bien" + bien.id },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to:
                                    "/portefeuille/" +
                                    portefeuille.id +
                                    "/" +
                                    site.id +
                                    "/" +
                                    bien.id
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(bien.name) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                }),
                0
              )
            ])
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }